<template>
    <v-form ref="userProfileForm">
        <p>Please note: if you change a user's email address their verification status will reset and they will need to reverify before being able to access MyGuild.</p>
        <user-profile-fields :initialValue="formData" @update="syncFormData" @validityChanged="syncFormValidity"></user-profile-fields>

        <!--Only show cancel if text is set. Always show submit, but only enable it if the form is valid-->
        <v-btn v-if="cancelButtonText" @click="raiseCancel" flat color="error">{{cancelButtonText}}</v-btn>
        <v-btn @click="submit" :disabled="!formValid">{{submitButtonText}}</v-btn>
    </v-form>
</template>

<script>
  import {FormMixin, BasicFormSyncMixin} from '@/forms/mixins'
  import UserProfileFields from '@/forms/user/UserProfileFields'

  export default {
    name: 'UserProfileForm',
    mixins: [FormMixin, BasicFormSyncMixin],
    components: {UserProfileFields},
  }
</script>

<style scoped>

</style>
